import React from 'react';
import ReactDOM from 'react-dom';
import logo from '../images/logo.png';

const Header=()=>
{
  return (
    <>
      <div className="container">
        <header className="d-flex flex-wrap justify-content-center py-3 mb-4">
          <a href="https://www.durichitayat.net/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
            <img src={logo} alt="Logo" className="logo" height="20" width="75"/>
          </a>

          <ul className="nav">
            <li className="nav-item"><a href="https://www.durichitayat.net/blog" className="nav-link">BLOG</a></li>
            <li className="nav-item"><a href="https://www.durichitayat.net/about" className="nav-link">ABOUT</a></li>
            <li className="nav-item"><a href="/tech-radar" className="nav-active nav-link" aria-current="page">RADAR</a></li>
            <li className="nav-item"><a target="_blank" href="http://twitter.com/durichitayat" className="nav-link icon"><i className="bi-twitter"></i></a></li>
            <li className="nav-item"><a target="_blank" href="https://www.linkedin.com/in/durichitayat" className="nav-link icon"><i className="bi-linkedin"></i></a></li>
          </ul>
        </header>
      </div>
    </>
  )
}

export default Header;
